import type React from 'react';

export const LoadingSkeleton: React.FC<EmptyProps> = () => {
	return (
		<div
			data-testid="media-hits-loading"
			className="animation-duration-[500ms] bg-fill-disabled h-51 w-full animate-pulse rounded-md"
		/>
	);
};
